<script lang="ts" setup>
import PrimeFloatLabel from 'primevue/floatlabel';

const props = defineProps<{ hidden?: boolean }>();
</script>

<template>
  <PrimeFloatLabel :pt="{ root: { hidden: props.hidden } }">
    <slot></slot>
  </PrimeFloatLabel>
</template>
